import * as React from 'react'

export function BC(props: {}){

   return <div className="sew-inst"> 
        <div className="title-main">Some People Did Something</div>

        <div className="contact-info-container">
            <div>If you would like a pattern, have questions, or need help,</div>
            <div>please send an e-mail to Sheri at  <a href = "mailto: DiapersforHaiti@outlook.com"> DiapersforHaiti@outlook.com</a>.</div> 
        </div>
        
   </div>
}